import type { Attachment } from "svelte/attachments"

export function clickOutside(fn: Function): Attachment {
  return (element) => {
    const listener = (e: MouseEvent) => {
      if (!element.contains(e.target as Node)) {
        fn(e)
      }
    }
    document.addEventListener("click", listener)

    return () => document.removeEventListener("click", listener)
  }
}
